export function gfAddOrSubtract(a: number, b: number): number {
  return a ^ b;
}
